<change-password>
    <div class="columns password-page">
        <div class="column col-mx-auto password-form">
            <h3>Ganti Kata Sandi</h3>
            <p class="text-gray">Gunakan minimal 10 karakter yang mengandung huruf dan angka sebelum melanjutkan.</p>
            <div if={state.message} class="toast toast-error">{state.message}</div>
            <input class="form-input" type="password" placeholder="Kata sandi saat ini" oninput={event => update({currentPassword: event.target.value})}>
            <input class="form-input mt-2" type="password" placeholder="Kata sandi baru" oninput={event => update({newPassword: event.target.value})}>
            <input class="form-input mt-2" type="password" placeholder="Ulangi kata sandi baru" oninput={event => update({confirmation: event.target.value})}>
            <button class="btn btn-primary mt-2 loading-{state.loading}" disabled={state.loading} onclick={submit}>Simpan Kata Sandi</button>
        </div>
    </div>
    <style>change-password .password-page { margin-top: 3rem; }</style>
    <script>
        import {router} from '@riotjs/route'
        export default {
            state: {currentPassword: '', newPassword: '', confirmation: '', message: '', loading: false},
            submit(event) {
                event.preventDefault()
                if (this.state.newPassword !== this.state.confirmation) { this.update({message: 'Konfirmasi kata sandi tidak sama'}); return }
                if (this.state.newPassword.length < 10 || !/[A-Za-z]/.test(this.state.newPassword) || !/[0-9]/.test(this.state.newPassword)) { this.update({message: 'Kata sandi baru harus minimal 10 karakter serta mengandung huruf dan angka'}); return }
                this.update({loading: true, message: ''})
                axios.post('/api/v1/teacher/password', {currentPassword: this.state.currentPassword, newPassword: this.state.newPassword})
                    .then(() => axios.get('/api/v1/teacher/session/validate'))
                    .then(response => router.push(response.data.role === 'platform_admin' ? '/#platform/schools' : '/'))
                    .catch(error => this.update({message: error.response && error.response.data && error.response.data.message || 'Kata sandi tidak dapat diubah'})).finally(() => this.update({loading: false}))
            },
        }
    </script>
</change-password>
